/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimableInvoiceItem } from './ClaimableInvoiceItem';
import {
    ClaimableInvoiceItemFromJSON,
    ClaimableInvoiceItemFromJSONTyped,
    ClaimableInvoiceItemToJSON,
    ClaimableInvoiceItemToJSONTyped,
} from './ClaimableInvoiceItem';

/**
 * 
 * @export
 * @interface PagedResultClaimableInvoiceItem
 */
export interface PagedResultClaimableInvoiceItem {
    /**
     * 
     * @type {Array<ClaimableInvoiceItem>}
     * @memberof PagedResultClaimableInvoiceItem
     */
    content: Array<ClaimableInvoiceItem>;
    /**
     * 
     * @type {number}
     * @memberof PagedResultClaimableInvoiceItem
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultClaimableInvoiceItem
     */
    totalPages: number;
}

/**
 * Check if a given object implements the PagedResultClaimableInvoiceItem interface.
 */
export function instanceOfPagedResultClaimableInvoiceItem(value: object): value is PagedResultClaimableInvoiceItem {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PagedResultClaimableInvoiceItemFromJSON(json: any): PagedResultClaimableInvoiceItem {
    return PagedResultClaimableInvoiceItemFromJSONTyped(json, false);
}

export function PagedResultClaimableInvoiceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedResultClaimableInvoiceItem {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(ClaimableInvoiceItemFromJSON)),
        'totalElements': json['totalElements'],
        'totalPages': json['totalPages'],
    };
}

export function PagedResultClaimableInvoiceItemToJSON(json: any): PagedResultClaimableInvoiceItem {
    return PagedResultClaimableInvoiceItemToJSONTyped(json, false);
}

export function PagedResultClaimableInvoiceItemToJSONTyped(value?: PagedResultClaimableInvoiceItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(ClaimableInvoiceItemToJSON)),
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}

